import {Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import React from "react";
import {NativeTypes} from "react-dnd-html5-backend";
import {DropTarget} from "react-dnd";
import dateHelper from "../core/dateHelper";

function sortByLastScanDate(myTargets){
    if(!myTargets){
        return myTargets;
    }
    return myTargets.sort((a,b) => dateHelper.compare2(a.lastScanDate,b.lastScanDate));
}

function MyTargetsTable(props){
    const {items, onDoubleClick} = props;
    return <Table size='small'>
        <TableHead>
            <TableRow>
                <TableCell align='left'>Full Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Last Scan Date</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                sortByLastScanDate(items).map(item => <TableRow
                    key={item.id}
                    onDoubleClick={()=>{
                        onDoubleClick(item.id);
                    }}
                >
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{dateHelper.toShortDate(item.lastScanDate)}</TableCell>
                </TableRow>)
            }
        </TableBody>
    </Table>
}



const Panel = ({
                          accepts,
                          isOver,
                          canDrop,
                          connectDropTarget,
                          lastDroppedItem,
                          items,
                          title,
                          selectable,
                          disabled,
                          onChange,
                          onDoubleClick
                      }) => {
    return connectDropTarget(
        <div>
            <Paper style={{
                //height: '30vh',
                paddingTop: '2vh', paddingLeft: '0',
                overflow: 'auto',
                backgroundColor: isOver ? '#77FF00' : canDrop ? '#DDFF77' : '#ddd'
            }} elevation={isOver ? 20 : canDrop ? 10 : 1}>
                {
                    items && items.length > 0 ?
                        <MyTargetsTable items={items} title={title}
                                         selectable={selectable}
                                         onDoubleClick={onDoubleClick}
                        />
                        :
                        <Typography variant='h6' component='h5' style={{height:'370px'}}
                                    align='center'>
                            {'Drag an employee list file here to upload targets to phish'}
                        </Typography>

                }
            </Paper>
        </div>
    )
}

const DropPanel = DropTarget(
    props => props.accepts,
    {
        drop(props, monitor) {
            props.onDrop(props, monitor)
        },
    },
    (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
    }),
)(Panel)

export function MyTargetsView(props) {
    const {onUpload,items,disabled,onChange,title,selectable,
        onDoubleClick
    } = props;
    const handleDrop = (item, monitor)=>{
        if (onUpload) {
            onUpload(monitor.getItem().files[0]);
        }
    };
    return <div>
        {
            disabled?
                <div></div>:
                <DropPanel accepts={[NativeTypes.FILE, NativeTypes.URL]}
                                items={items}
                                title={title}
                                disabled={disabled}
                                onChange={onChange}
                                selectable={selectable}
                                onDoubleClick={onDoubleClick}
                                lastDroppedItem={null} onDrop={handleDrop} />

        }

    </div>;
}